<template>
    <div><!-- min height because list goes off page -->
        <txt label="first_name" v-model="model.first_name"></txt>
        <txt label="last_name" v-model="model.last_name"></txt>
        <txt label="email" v-model="model.email"></txt>

        <div class="buttons">
            <button class="btn btn-success btn-sml" @click.prevent="store"><i class="icon icon-save"></i> Save</button>
        </div>
    </div>
</template>
<script>
    export default {
        props: {
            name: { default: '' },
        },
        components: {
        },
        data() {
            return {
                model: {
                    first_name: '',
                    last_name: '',
                    email: '',
                }
            }
        },
        created() {},
        methods: {
            store(){
                this.$store('/api/user/store', this);
            }
        }
    }
</script>